export const EDIT_TNS_FORM = 'checkout/payment/EDIT_TNS_FORM';
export const editTnsForm = (payload) => ({
  type: EDIT_TNS_FORM,
  payload,
});
